var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_1745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8939 4.11084C13.0583 4.11084 4.26416 13.0406 4.26416 24.0433C4.26416 35.0461 13.0583 43.9758 23.8939 43.9758C34.7295 43.9758 43.5236 35.0461 43.5236 24.0433C43.5236 13.0406 34.7295 4.11084 23.8939 4.11084ZM19.9679 33.013V15.0737L31.7458 24.0433L19.9679 33.013Z",
    fill: "#602EF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_1745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.1113,
    height: 47.838,
    fill: "white",
    transform: "translate(0.338379 0.124268)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.d9a31b91f2431e0cd13ad8d15a65e0de.svg";
export { ForwardRef as ReactComponent };